import ModuleListV4 from './ModuleListV4';
import ModuleSectionV4 from './ModuleSectionV4';
import {IsUnionModuleContext} from '../common';
import {IUnionModuleV4} from '../type';

interface IProps {
  data: IUnionModuleV4;
}

export default function UnionModuleV4({data}: IProps) {
  const {section, moduleList} = data;

  return (
    <ModuleSectionV4
      data-module-type={data.moduleType}
      section={section}
      // 각 추가 모듈에 EventMaxWidthV4 적용되어 있어서 -mx-18 입력한다.
      innerClassName="flex flex-col -mx-18"
    >
      <IsUnionModuleContext.Provider value={true}>
        <ModuleListV4 moduleList={moduleList} />
      </IsUnionModuleContext.Provider>
    </ModuleSectionV4>
  );
}
